<app-page-base>
  <!-- Stato di caricamento centralizzato -->
  <div *ngIf="loading" class="flex h-full flex-1 items-center justify-center gap-3 p-4">
    <strong class="text-surface-700 dark:text-surface-300">{{ 'loading' | translate }}</strong>
    <p-progress-spinner aria-label="Caricamento" [style]="{ width: '4rem', height: '4rem' }" />
  </div>

  <!-- Contenitore rigido per lo scroll della tabella (100vh - header - padding) -->
  <div *ngIf="!loading" class="flex h-[calc(100vh-theme(spacing.12)-theme(spacing.8))] min-h-0 w-full flex-col">
    <ng-content></ng-content>
  </div>
</app-page-base>
